import { ResourceDto } from '@lmt/shared-types';

export enum SortDirections {
  Descending = 0,
  Ascending = 1,
  None = 3,
}

const compareNonEmptyStrings = (str1: string, str2: string): -1 | 0 | 1 => {
  if (str1 && str2) {
    if (str1.toString().toLowerCase() < str2.toString().toLowerCase())
      return -1;
    if (str1.toString().toLowerCase() > str2.toString().toLowerCase()) return 1;
  }
  return 0;
};

export const compareFunctions = {
  asStrings: compareNonEmptyStrings,
};

export const sortItems = <T extends { [index: string]: any }>(
  items: T[],
  direction: SortDirections,
  propName: string,
  compareFunction: (val1: any, val2: any) => number,
): T[] => {
  if (direction === SortDirections.Descending) {
    return items.sort((item1, item2) =>
      compareFunction(item1[propName], item2[propName]),
    );
  }
  if (direction === SortDirections.Ascending) {
    return items
      .sort((item1, item2) => compareFunction(item1[propName], item2[propName]))
      .reverse();
  }

  throw Error(`Sort direction ${direction} is not suported`);
};

export const sortResources = (room1: ResourceDto, room2: ResourceDto) => {
  return sortResourceValues(room1.name, room2.name);
};

export const sortResourceValues = (room1: string, room2: string): 1 | -1 => {
  if (!room1 && !room2) {
    return 1;
  } else if (!room1 && room2) {
    return 1;
  } else if (room1 && !room2) {
    return -1;
  }
  const reg = /(\d+)/;
  // 'Floor 1 Room 2' => ['floor', '1', 'room', 2];
  const a = room1.replace(/\s/g, '').toLowerCase();
  const b = room2.replace(/\s/g, '').toLowerCase();
  const alist = a.split(reg);
  const blist = b.split(reg);
  // max length array
  const n = alist.length > blist.length ? alist.length : blist.length;
  for (let i = 0; i < n; i++) {
    const ai = alist[i];
    const bi = blist[i];
    if (ai && !bi) {
      return 1;
    } else if (!ai && bi) {
      return -1;
    } else if (ai === bi) {
      continue;
    } else {
      // 'room' => 'room', '10' => 10
      const x = isNaN(parseInt(ai)) ? ai : parseInt(ai);
      const y = isNaN(parseInt(bi)) ? bi : parseInt(bi);
      return x > y ? 1 : -1;
    }
  }
  return 1;
};
